import {Component, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ControlValueAccessor, FormBuilder, FormControl, NG_VALUE_ACCESSOR} from '@angular/forms';
import {startWith, takeUntil} from 'rxjs/operators';
import {MatSelectChange} from '@angular/material/select';
import {Department} from '../../interface/department';
import {DepartmentService} from '../../services/department.service';
import {ListResponse} from '../../interface/response/list-response';
import {ReplaySubject} from 'rxjs';

@Component({
  selector: 'app-dict-departments',
  templateUrl: './dict-departments.component.html',
  styleUrls: ['./dict-departments.component.scss'],
  providers: [
    {provide: NG_VALUE_ACCESSOR, multi: true, useExisting: forwardRef(() => DictDepartmentsComponent)}
  ]
})
export class DictDepartmentsComponent implements OnInit, OnDestroy, ControlValueAccessor {
  @Input() label: string;
  @Input() multiple = false;
  @Input() control: FormControl = null;
  @Input() required = false;

  externalControl = true;
  disabled = false;
  items: Department[] = [];
  selectedItems: Department[] = [];
  value?: number = null;
  departmentFilterCtrl: FormControl;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private departmentService: DepartmentService,
    private fb: FormBuilder,
  ) {
    this.departmentFilterCtrl = fb.control('');
  }

  onChange: any = () => { };
  onTouched: any = () => { };

  ngOnInit(): void {

    this.departmentService.getDepartmentNotCountedListSubject()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((response: ListResponse<Department>) => {
        this.items = response.items;
      });
    if (this.multiple) {
      this.departmentService.loadNotCountedList(0, 50, {});
    }

    this.departmentFilterCtrl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((val: string) => {
        // if (this.multiple) {
        // } else {
        if (val) {
          this.departmentService.loadNotCountedList(0, 5, {contains$name: val});
        } else if (this.control.value) {
          if (this.multiple) {
            this.departmentService.loadNotCountedList(0, 50, {});
          } else {
            this.departmentService.loadNotCountedList(0, 5, {uuid: this.control.value});
          }
        }
        // }
      });

    if (this.control === null) {
      this.control = new FormControl('');
      this.externalControl = false;
    }

    this.control.valueChanges
      .pipe(
        startWith(this.control.value),
        takeUntil(this.destroyed$)
      )
      .subscribe((val: string) => {
        if (val) {
          let exists = false;
          this.items.forEach((department: Department) => {
            if (department.uuid === val) {
              exists = true;
            }
          });

          if (!exists && this.multiple === false) {
            this.departmentService.loadNotCountedList(0, 3, {
              uuid: val
            });
          }
        }
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (this.externalControl) {
      return;
    }

    if (isDisabled) {
      this.control.disable();
    } else {
      this.control.enable();
    }

    this.disabled = isDisabled;
  }

  writeValue(value: any): void {
    if (this.externalControl) {
      return;
    }

    this.control.setValue(value);
    this.value = value;
    this.selectedItems = value;
  }

  onSelectionChange(e: MatSelectChange): void {
    this.value = e.value;
    this.onChange(this.value);
  }

  clearValue(): void {
    this.control.setValue(this.multiple ? [] : '');
    this.writeValue(this.multiple ? [] : '');
    this.onChange(this.value);
    this.selectedItems = [];
  }
}
